import React from 'react';
import { Monitor } from 'lucide-react';
import { useDarkMode } from '../../../contexts/DarkModeContext';
import { TemplateGrid } from './components/TemplateGrid';
import { TemplateToggle } from './components/TemplateToggle';
import { useClockTemplates } from './hooks/useClockTemplates';
import { sectionStyles } from './styles';

export const DisplaySettings = ({
  showImageTemplates,
  setShowImageTemplates,
  selectedTemplate,
  setSelectedTemplate,
  onSave,
  settings
}) => {
  const { isDarkMode } = useDarkMode();
  const styles = sectionStyles(isDarkMode);
  const { templates } = useClockTemplates(selectedTemplate);

  const image = templates.filter(t => t.photos);
  const basic = templates.filter(t => !t.photos);

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template.id);
    const newSettings = {
      ...settings.simpleDashboard,
      templateId: template.id,
      ...template.builtIn?.defaultSettings,
      userSettings: settings.simpleDashboard?.userSettings || {}
    };

    onSave(newSettings);
  };

  return (
    <section className={`${styles.container} relative z-0`}>
      <div className={styles.header}>
        <Monitor className={styles.headerIcon} />
        <h2 className={styles.headerText}>Display Settings</h2>
      </div>
      <div className={styles.card}>
        <TemplateToggle
          showImageTemplates={showImageTemplates}
          setShowImageTemplates={setShowImageTemplates}
        />
        <TemplateGrid
          templates={showImageTemplates ? image : basic}
          selectedTemplate={selectedTemplate}
          onSelect={handleTemplateSelect}
          showPortraitDivider={showImageTemplates}
        />
      </div>
    </section>
  );
};